import { BlobCtaButton, CardGlass, Typography } from "@cupcodev/ui";
import { useI18n } from "../app/i18n/I18nProvider";
import { CtaLink, NaveIcon } from "./NavePage";

/** Customer-facing errors use localized copy, never internal query codes. */
export const CustomerError = ({ title, description, inline = false }: {
  title: string;
  description: string;
  inline?: boolean;
}) => {
  const { t } = useI18n();
  return <CardGlass variant={inline ? "glass-sm" : "glass-md"} elevation={0} className={inline ? "nave-error nave-error-inline" : "nave-error"}>
    <span className="nave-empty-icon" aria-hidden="true"><NaveIcon name="lucide:cloud-alert" /></span>
    <div className="nave-empty-copy">
      <Typography as={inline ? "h3" : "h1"} variant={inline ? "title-sm" : "title-lg"}>{title}</Typography>
      <Typography as="p" variant="body-sm" tone="muted">{description}</Typography>
    </div>
    {inline ? null : <div className="nave-form-actions">
      <BlobCtaButton type="button" size="sm" variant="secondary" onClick={() => window.location.reload()}><NaveIcon name="lucide:rotate-cw" />{t("common.retry")}</BlobCtaButton>
      <CtaLink to="/" icon="lucide:house">{t("errors.notFound.back")}</CtaLink>
    </div>}
  </CardGlass>;
};
